import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import DashboardPage from './pages/DashboardPage';
import RoadmapPage from './pages/RoadmapPage';
import ChangelogPage from './pages/ChangelogPage';
import ImportFeedbackPage from './pages/ImportFeedbackPage';
import SettingsPage from './pages/SettingsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import PricingPage from './pages/PricingPage';
import FAQPage from './pages/FAQPage';
import CookiePolicyPage from './pages/CookiePolicyPage';
import RefundPolicyPage from './pages/RefundPolicyPage';
import ComparisonPage from './pages/ComparisonPage';
import FeaturePage from './pages/FeaturePage';
import PublicRoadmapPage from './pages/PublicRoadmapPage';
import PublicChangelogPage from './pages/PublicChangelogPage';
import WeeklyDigestPage from './pages/WeeklyDigestPage';
import PlaybookPage from './pages/PlaybookPage';
import SourcesPage from './pages/SourcesPage';
import SharePage from './pages/SharePage';
import BrandingPage from './pages/settings/BrandingPage';
import TeamPage from './pages/settings/TeamPage';
import DomainPage from './pages/settings/DomainPage';
import PrivacyPage from './pages/settings/PrivacyPage';
import IntegrationsPage from './pages/settings/IntegrationsPage';
import ApiTokensPage from './pages/settings/ApiTokensPage';
import BillingPage from './pages/settings/BillingPage';
import DataExportPage from './pages/settings/DataExportPage';
import ErrorBoundary from './components/ErrorBoundary';
import OfflineBanner from './components/OfflineBanner';
import CookieConsentBanner from './components/CookieConsentBanner';
import { WorkspaceProvider } from './contexts/WorkspaceContext';
import { ThemeProvider } from './contexts/ThemeContext';
import CommandPalette from './components/CommandPalette';
import ReceiptsPage from './pages/ReceiptsPage';
import { Toaster } from './components/ui/sonner';
import { COMPARE_ENABLED } from './lib/features';
import './App.css';

function App() {
  return (
    <ErrorBoundary>
      <OfflineBanner />
      <Router>
        <ThemeProvider>
          <WorkspaceProvider>
            <div className="App">
            {/* Subtle noise overlay */}
            <div className="noise-overlay" aria-hidden="true" />

            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/app" element={<DashboardPage />} />
              <Route path="/roadmap" element={<RoadmapPage />} />
              <Route path="/changelog" element={<ChangelogPage />} />
              <Route path="/import" element={<ImportFeedbackPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/cookies" element={<CookiePolicyPage />} />
              <Route path="/refund" element={<RefundPolicyPage />} />
              <Route
                path="/compare/:slug"
                element={COMPARE_ENABLED ? <ComparisonPage /> : <Navigate to="/" replace />}
              />
              <Route path="/features/:slug" element={<FeaturePage />} />
              <Route path="/r/:slug" element={<PublicRoadmapPage />} />
              <Route path="/c/:slug" element={<PublicChangelogPage />} />
              <Route path="/digest" element={<WeeklyDigestPage />} />
              <Route path="/receipts" element={<ReceiptsPage />} />
              <Route path="/playbook" element={<PlaybookPage />} />
              <Route path="/sources" element={<SourcesPage />} />
              <Route path="/share" element={<SharePage />} />
              <Route path="/settings/branding" element={<BrandingPage />} />
              <Route path="/settings/team" element={<TeamPage />} />
              <Route path="/settings/domain" element={<DomainPage />} />
              <Route path="/settings/privacy" element={<PrivacyPage />} />
              <Route path="/settings/integrations" element={<IntegrationsPage />} />
              <Route path="/settings/api-tokens" element={<ApiTokensPage />} />
              <Route path="/settings/billing" element={<BillingPage />} />
              <Route path="/settings/data" element={<DataExportPage />} />
              <Route path="/privacy" element={<PrivacyPolicyPage />} />
              <Route path="/terms" element={<TermsOfServicePage />} />
            </Routes>

            <Toaster />
            <CommandPalette />
            <CookieConsentBanner />
          </div>
          </WorkspaceProvider>
        </ThemeProvider>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
